import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { getToken } from 'Apis/demographics'
import { propertyUseQuery } from 'Services/reactQuery'

import Demographics from './index'


const DemographicsApiContainer = props => {
  const { listing, building, googleAnalyticsEvent = () => {}, school } = props
  const address = listing ? listing.address : building ? building.primary_address : school ?
    school.primary_address : ''

  if(address?.latlng_json || address?.lat) {
    const { lat, lng } = address.latlng_json ? JSON.parse(address.latlng_json) : address

    const getDemographics = async () => {
      try {
        const token = await getToken()
        const config = {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            lat,
            lng,
          },
        }
        const { data } = await axios.get(
          'https://api.locallogic.co/v3/demographics', config,
        )
        return data
      } catch(e) {
        // console.log(e)
      }
    }


    const { isLoading, data: demographicsData } = propertyUseQuery(
      ['demographics', address.id],
      getDemographics,
      {
        staleTime: 5,
        cacheTime: 5,
        onSuccess: () => {
          googleAnalyticsEvent({
            category: 'demographics',
            action: 'locallogic called',
          })
        },
        enabled: !!(address),
        select: data => data,
      },
    )

    return (
      <Demographics
        {...props}
        data={demographicsData}
        isLoading={isLoading}
      />
    )
  }
  return ''
}

DemographicsApiContainer.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  areaName: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  listing: PropTypes.shape({
    address: PropTypes.shape({}),
  }),
  building: PropTypes.shape({
    primary_address: PropTypes.shape({}),
  }),
  school: PropTypes.shape({
    primary_address: PropTypes.shape({}),
  }),
}

export default DemographicsApiContainer
